import styled from 'styled-components';

export const FieldValidationCellStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .form-group {
    margin-bottom: 0;

    & > div {
      padding: 0;
    }
  }
`;
